import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { LeadContato } from '../lead-contato';
import { PessoaContatoTipo } from '../../../../pessoa/contato';

@Injectable({
    providedIn: 'root'
})
export class LeadContatoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/lead`;
    }

    /** Carrega o contato através do seu ID */
    load(idContato: number): Observable<LeadContato> {
        return this.customHttp.get<LeadContato>(`${this.pathApi}/0/contato/${idContato}`);
    }

    /** Procura o contato do lead e tipo informados */
    findContato(idLead: number, tipo: PessoaContatoTipo): Observable<LeadContato> {
        // Params
        const params = new HttpParams()
                            .append('tipo', tipo ? tipo.id.toString() : 'null');

        return this.customHttp.get<LeadContato>(`${this.pathApi}/${idLead}/contato`, {params});
    }

    /** Pesquisa os contatos do lead informado */
    searchContatos(idLead: number): Observable<LeadContato[]> {
        return this.customHttp.get<LeadContato[]>(`${this.pathApi}/${idLead}/contatos`);
    }

    /** Insere um novo contato */
    insert(idLead: number, entity: LeadContato): Observable<LeadContato> {
        return this.customHttp.post<LeadContato>(`${this.pathApi}/${idLead}/contato`, entity);
    }

    /** Atualiza um contato */
    update(entity: LeadContato): Observable<LeadContato> {
        return this.customHttp.put<LeadContato>(`${this.pathApi}/0/contato`, entity);
    }
}
